"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceMode = void 0;
var DeviceMode;
(function (DeviceMode) {
    DeviceMode["desktop"] = "desktop";
    DeviceMode["tablet"] = "tablet";
    DeviceMode["mobile"] = "mobile";
})(DeviceMode || (exports.DeviceMode = DeviceMode = {}));
